/**
 * Timeline Widget tokens (Figma DS AIMS OS — node 15990:8183 … 15990:8190).
 *
 * A color-coded, read-only card: value (bold, colored) + title (shared body
 * color) + a swappable icon. Color conveys category, not sequence. Palette
 * mirrors HighlightCard so the two dashboard families stay visually aligned.
 * Yellow / Lime Green have no dedicated border token in the DS — their value
 * text color doubles as the border, matched here with a readable text shade.
 */

/** Figma `Color` property values. */
export const TIMELINE_CARD_VARIANTS = [
  'primary',
  'red',
  'orange',
  'green',
  'purple',
  'lightBlue',
  'yellow',
  'limeGreen',
];

/** Per-variant surface + border (`container`) and value/icon text color (`text`). */
export const TIMELINE_VARIANT_STYLES = {
  primary: {
    container: 'border-[#2173ff] bg-[#f6f9ff] dark:border-blue-800/60 dark:bg-blue-950/35',
    text: 'text-[#2173ff] dark:text-blue-300',
  },
  red: {
    container: 'border-[#d32f2f] bg-[#fdeded] dark:border-red-800/60 dark:bg-red-950/35',
    text: 'text-[#d32f2f] dark:text-red-300',
  },
  orange: {
    container: 'border-[#ed6c02] bg-[#fff4e5] dark:border-amber-700/60 dark:bg-amber-950/35',
    text: 'text-[#ed6c02] dark:text-amber-300',
  },
  green: {
    container: 'border-[#00a07e] bg-[#e5fdf8] dark:border-emerald-800/60 dark:bg-emerald-950/35',
    text: 'text-[#00a07e] dark:text-emerald-300',
  },
  purple: {
    container: 'border-[#b070f5] bg-[#f3e9fd] dark:border-purple-700/60 dark:bg-purple-950/35',
    text: 'text-[#8b3ff0] dark:text-purple-300',
  },
  lightBlue: {
    container: 'border-[#00b5d9] bg-[#e5f8ff] dark:border-sky-700/60 dark:bg-sky-950/35',
    text: 'text-[#0090ad] dark:text-sky-300',
  },
  yellow: {
    container: 'border-[#ff9900] bg-[#fffaf0] dark:border-amber-600/60 dark:bg-amber-950/30',
    text: 'text-[#b57400] dark:text-amber-300',
  },
  limeGreen: {
    container: 'border-[#a0da1d] bg-[#f9fee5] dark:border-lime-600/60 dark:bg-lime-950/30',
    text: 'text-[#6d9200] dark:text-lime-300',
  },
};

/** Accepts only documented {@link TIMELINE_CARD_VARIANTS}; unknown values fall back to `primary`. */
export const normalizeTimelineCardVariant = (variant) =>
  TIMELINE_CARD_VARIANTS.includes(variant) ? variant : 'primary';
